import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit, Renderer2 } from '@angular/core';

import {Router} from '@angular/router';
import {RestapiService} from '../restapi.service';

@Component({
  selector: 'app-ceo',
  templateUrl: './ceo.component.html',
  styleUrls: ['./ceo.component.css']
})
export class CeoComponent implements OnInit {
	anio: number = new Date().getFullYear();
	constructor(@Inject(DOCUMENT) private document: Document,
	private renderer: Renderer2,private router: Router, private _rest: RestapiService) { }

	ngOnInit(): void {
  	}
  	sideNavToggle(){
    	if(document.getElementsByTagName("body")[0].className.match(/open/)){
      		this.renderer.removeClass(this.document.body, 'open');
    	} else {
      		this.renderer.addClass(this.document.body, 'open');
    	}
  }
  ddToggleMenu(){
	if(document.getElementById("ddLogout").className.match(/show/)){
      this.renderer.removeClass(document.getElementById("ddMenu"), 'show');
      this.renderer.removeClass(document.getElementById("ddLogout"), 'show');
    } else {
      this.renderer.addClass(document.getElementById("ddMenu"), 'show');
      this.renderer.addClass(document.getElementById("ddLogout"), 'show');
    }
  }
  glogout() {
    localStorage.clear();
    this.router.navigate(['/']);
  }
  ngOnDestroy(): void {
    this.renderer.removeClass(this.document.body, 'open');
  }
}
